webpackJsonp([0],{

/***/ "+6RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0puC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_component_vue__ = __webpack_require__("w1Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d613e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_component_vue__ = __webpack_require__("M959");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d613e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "31cC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_component_vue__ = __webpack_require__("fCdN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c4e93ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_component_vue__ = __webpack_require__("4VVJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c4e93ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "38EM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{attrs:{"content-class":'margin-left-105',"persistent":true},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"blue--text headline"},[_vm._v("Lollicup Guests, we are open for takeout!")])]),_vm._v(" "),_c('v-card-text',[_c('v-row',[(_vm.showAnnouncement)?_c('v-col',[_c('span',{staticClass:"subtitle-1 red--text font-weight-bold"},[_vm._v("Announcement:")]),_vm._v(" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v("\n                Memorial Day (Monday, May 31, 2021) Hours: 12:00 P.M. - 6:00 P.M.\n              ")])]):_c('v-col',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("\n                We are thankful that we can still provide our guests with the option to take out, as well as the\n                ability to order for delivery through\n                "),_c('a',{attrs:{"href":"https://postmates.com/merchant/lollicup-1589-s-colorado-blvd","target":"_blank"}},[_vm._v("PostMates")]),_vm._v("!\n              ")])])],1),_vm._v(" "),_c('v-row',[_c('v-col',[_c('span',[_vm._v("\n                As COVID-19 has greatly effected the food service industry, we will be tentatively adjusting our\n                hours of operation to the following:\n              ")])])],1),_vm._v(" "),_vm._l((_vm.dialogHoursOfOperation),function(item){return _c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","xs":"4","sm":"3","md":"2"}},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.dayOfWeek))])])]),_vm._v(" "),_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","xs":"8","sm":"9","md":"10"}},[_c('div',[_c('span',[_vm._v(_vm._s(item.hours))])])])],1)})],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text",on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Close")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3rSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_config__ = __webpack_require__("Pqsl");


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    /**
     * getComponentImagePath will return the path to the the image source, which can changed based on the Config
     * variable 'siteMediaLoadQuality'. This value will be set manually for now, defaulting to "mq" (medium quality).
     */
    getComponentImagePath: function getComponentImagePath(imageFile) {
      var pageImagePath = '';

      if (__WEBPACK_IMPORTED_MODULE_0__js_config__["a" /* default */].siteMediaLoadQuality === 'hq') {
        pageImagePath = 'static/images/component/images_hq/' + imageFile;
      } else if (__WEBPACK_IMPORTED_MODULE_0__js_config__["a" /* default */] === 'lq') {
        pageImagePath = 'static/images/component/images_lq/' + imageFile;
      } else {
        pageImagePath = 'static/images/component/images_mq/' + imageFile;
      }
      return pageImagePath;
    },


    /**
     * getGalleryImagePath will return the path to the the image source, which can changed based on the Config
     * variable 'siteMediaLoadQuality'. This value will be set manually for now, defaulting to "mq" (medium quality).
     */
    getGalleryImagePath: function getGalleryImagePath(imageFile) {
      var pageImagePath = '';

      if (__WEBPACK_IMPORTED_MODULE_0__js_config__["a" /* default */].siteMediaLoadQuality === 'hq') {
        pageImagePath = 'static/images/gallery/images_hq/' + imageFile;
      } else if (__WEBPACK_IMPORTED_MODULE_0__js_config__["a" /* default */] === 'lq') {
        pageImagePath = 'static/images/gallery/images_lq/' + imageFile;
      } else {
        pageImagePath = 'static/images/gallery/images_mq/' + imageFile;
      }
      return pageImagePath;
    }
  }
});

/***/ }),

/***/ "4VVJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home ld-background ld-right-slide ld-scroll-none"},[(_vm.screenWidthSmall)?_c('div',{staticClass:"ld-logo-right-slide",class:{'pr-4' : _vm.screenWidthSmall}},[_c('img',{staticClass:"ld-width-100",attrs:{"src":_vm.getComponentImagePath('lollicup_logo_transparency_400_201.png')}})]):_vm._e(),_vm._v(" "),_c('nav-slide-component',{attrs:{"setClassContainer":'ld-right-slide ld-scroll-none',"setClassImage":'ld-right-slide-image',"setIdImage":_vm.imageIdDrinks,"setSourceImage":_vm.getComponentImagePath('lollicup_food_drinks_1799_1200.jpg'),"setStyleContainer":'',"setStyleImage":_vm.setImageStyleDrinks},on:{"imageMounted":_vm.imageMountedLollicupFoodDrinks}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4kVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    onClickNav1: function onClickNav1(element) {
      this.$emit('onClickNav1', element);
    },

    onClickNav2: function onClickNav2(element) {
      this.$emit('onClickNav2', element);
    },

    onClickNav3: function onClickNav3(element) {
      this.$emit('onClickNav3', element);
    },

    onClickNav4: function onClickNav4(element) {
      this.$emit('onClickNav4', element);
    },

    onClickNav5: function onClickNav5(element) {
      this.$emit('onClickNav5', element);
    }
  },

  name: 'navigationMenuComponent',

  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "5+Wq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: [{
    dairy: false,
    favorite: false,
    flavor: 'Black',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Ginger',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Grape',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Green Apple',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Honey',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Jasmine',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Kiwi',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Lemon',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Longan',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Mango',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Passion',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Peach',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Peppermint',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Pomegranate',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Raspberry',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Rose',
    premium: true
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Sour Plum',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Strawberry',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Yogurt',
    premium: false
  }]
});

/***/ }),

/***/ "5fxe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_utils__ = __webpack_require__("mF0L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__about_component_vue__ = __webpack_require__("0puC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contact_component_vue__ = __webpack_require__("er3Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gallery_component_vue__ = __webpack_require__("f+Mp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_general_mixin__ = __webpack_require__("3rSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_component_vue__ = __webpack_require__("31cC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menu_component_vue__ = __webpack_require__("6gBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_landing_popup_vue__ = __webpack_require__("zANs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__nav_slide_component_vue__ = __webpack_require__("E28O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__navigation_main_component_vue__ = __webpack_require__("jrSg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AboutComponent: __WEBPACK_IMPORTED_MODULE_1__about_component_vue__["a" /* default */],
    ContactComponent: __WEBPACK_IMPORTED_MODULE_2__contact_component_vue__["a" /* default */],
    GalleryComponent: __WEBPACK_IMPORTED_MODULE_3__gallery_component_vue__["a" /* default */],
    HomeComponent: __WEBPACK_IMPORTED_MODULE_5__home_component_vue__["a" /* default */],
    MenuComponent: __WEBPACK_IMPORTED_MODULE_6__menu_component_vue__["a" /* default */],
    ModalLandingPopup: __WEBPACK_IMPORTED_MODULE_7__modal_landing_popup_vue__["a" /* default */],
    NavSlideComponent: __WEBPACK_IMPORTED_MODULE_8__nav_slide_component_vue__["a" /* default */],
    NavigationMainComponent: __WEBPACK_IMPORTED_MODULE_9__navigation_main_component_vue__["a" /* default */]
  },

  methods: {
    /**
     * getWindowHeight will get the browser view window height.
     */
    getWindowHeight: function getWindowHeight() {
      this.windowHeight = __WEBPACK_IMPORTED_MODULE_0__js_utils__["d" /* getWindowHeight */](document);
    },

    /**
     * getWindowWidth will get the browser view window width.
     */
    getWindowWidth: function getWindowWidth() {
      this.windowWidth = __WEBPACK_IMPORTED_MODULE_0__js_utils__["e" /* getWindowWidth */](document);
    },

    /**
     * imageMountedLollicupBooks will listen for the image mounted event from the nav slide component, then get and
     * set the image style left offset for the Lollicup books image. This functionality was created because the width
     * of the image may not be available on any of the built in Vue instance functions, due to loading delays.
     */
    imageMountedLollicupBooks: function imageMountedLollicupBooks() {
      this.setImageStyleBooks.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdBooks, this.screenWidthSmall, this.windowWidth);
    },

    /**
     * imageMountedLollicupCheers will listen for the image mounted event from the nav slide component, then get and
     * set the image style left offset for the Lollicup cheers image. This functionality was created because the
     * width of the image may not be available on any of the built in Vue instance functions, due to loading delays.
     */
    imageMountedLollicupCheers: function imageMountedLollicupCheers() {
      this.setImageStyleCheers.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdCheers, this.screenWidthSmall, this.windowWidth);
    },

    /**
     * imageMountedLollicupOpenNight will listen for the image mounted event from the nav slide component, then get
     * and set the image style left offset for the Lollicup open night image. This functionality was created because
     * the width of the image may not be available on any of the built in Vue instance functions, due to loading
     * delays.
     */
    imageMountedLollicupOpenNight: function imageMountedLollicupOpenNight() {
      this.setImageStyleOpenNight.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdOpenNight, this.screenWidthSmall, this.windowWidth);
    },

    /**
     * imageMountedLollicupSnacks will listen for the image mounted event from the nav slide component, then get and
     * set the image style left offset for the Lollicup snacks image. This functionality was created because the
     * width of the image may not be available on any of the built in Vue instance functions, due to loading delays.
     */
    imageMountedLollicupSnacks: function imageMountedLollicupSnacks() {
      this.setImageStyleSnacks.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdSnacks, this.screenWidthSmall, this.windowWidth);
    },

    /**
     * imageMountedLollicupSteamedBuns will listen for the image mounted event from the nav slide component, then get
     * and set the image style left offset for the Lollicup steamed buns image. This functionality was created
     * because the width of the image may not be available on any of the built in Vue instance functions, due to
     * loading delays.
     */
    imageMountedLollicupSteamedBuns: function imageMountedLollicupSteamedBuns() {
      this.setImageStyleSteamedBuns.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdSteamedBuns, this.screenWidthSmall, this.windowWidth);
    },

    /**
     * onClickNav1 will listen for the click event of the first navigation button, then call the
     * 'transitionSlides' to transition the left and right slides.
     */
    onClickNav1: function onClickNav1() {
      this.transitionSlides(1);
    },

    /**
     * onClickNav2 will listen for the click event of the second navigation button, then call the
     * 'transitionSlides' to transition the left and right slides.
     */
    onClickNav2: function onClickNav2() {
      this.transitionSlides(2);
    },

    /**
     * onClickNav3 will listen for the click event of the third navigation button, then call the
     * 'transitionSlides' to transition the left and right slides.
     */
    onClickNav3: function onClickNav3() {
      this.transitionSlides(3);
    },

    /**
     * onClickNav4 will listen for the click event of the fourth navigation button, then call the
     * 'transitionSlides' to transition the left and right slides.
     */
    onClickNav4: function onClickNav4() {
      this.transitionSlides(4);
    },

    /**
     * onClickNav5 will listen for the click event of the fifth navigation button, then call the
     * 'transitionSlides' to transition the left and right slides.
     */
    onClickNav5: function onClickNav5() {
      this.transitionSlides(5);
    },

    /**
     * transitionSlides will set the slide transition values appropriately, determined by the argument provided.
     * @param navDestination - integer - the navigation button clicked.
     */
    transitionSlides: function transitionSlides(navDestination) {
      switch (navDestination) {
        case 1:
          this.leftSlide1Translate = 'translate(0, 0)';
          this.leftSlide2Translate = 'translate(0, 0)';
          this.leftSlide3Translate = 'translate(0, 0)';
          this.leftSlide4Translate = 'translate(0, 0)';
          this.leftSlide5Translate = 'translate(0, 0)';

          this.rightSlide1Translate = 'translate(0, 0)';
          this.rightSlide2Translate = 'translate(0, 0)';
          this.rightSlide3Translate = 'translate(0, 0)';
          this.rightSlide4Translate = 'translate(0, 0)';
          this.rightSlide5Translate = 'translate(0, 0)';
          break;

        case 2:
          this.leftSlide1Translate = 'translate(0, 100%)';
          this.leftSlide2Translate = 'translate(0, 100%)';
          this.leftSlide3Translate = 'translate(0, 100%)';
          this.leftSlide4Translate = 'translate(0, 100%)';
          this.leftSlide5Translate = 'translate(0, 100%)';

          this.rightSlide1Translate = 'translate(0, -100%)';
          this.rightSlide2Translate = 'translate(0, -100%)';
          this.rightSlide3Translate = 'translate(0, -100%)';
          this.rightSlide4Translate = 'translate(0, -100%)';
          this.rightSlide5Translate = 'translate(0, -100%)';
          break;

        case 3:
          this.leftSlide1Translate = 'translate(0, 200%)';
          this.leftSlide2Translate = 'translate(0, 200%)';
          this.leftSlide3Translate = 'translate(0, 200%)';
          this.leftSlide4Translate = 'translate(0, 200%)';
          this.leftSlide5Translate = 'translate(0, 200%)';

          this.rightSlide1Translate = 'translate(0, -200%)';
          this.rightSlide2Translate = 'translate(0, -200%)';
          this.rightSlide3Translate = 'translate(0, -200%)';
          this.rightSlide4Translate = 'translate(0, -200%)';
          this.rightSlide5Translate = 'translate(0, -200%)';
          break;

        case 4:
          this.leftSlide1Translate = 'translate(0, 300%)';
          this.leftSlide2Translate = 'translate(0, 300%)';
          this.leftSlide3Translate = 'translate(0, 300%)';
          this.leftSlide4Translate = 'translate(0, 300%)';
          this.leftSlide5Translate = 'translate(0, 300%)';

          this.rightSlide1Translate = 'translate(0, -300%)';
          this.rightSlide2Translate = 'translate(0, -300%)';
          this.rightSlide3Translate = 'translate(0, -300%)';
          this.rightSlide4Translate = 'translate(0, -300%)';
          this.rightSlide5Translate = 'translate(0, -300%)';
          break;

        case 5:
          this.leftSlide1Translate = 'translate(0, 400%)';
          this.leftSlide2Translate = 'translate(0, 400%)';
          this.leftSlide3Translate = 'translate(0, 400%)';
          this.leftSlide4Translate = 'translate(0, 400%)';
          this.leftSlide5Translate = 'translate(0, 400%)';

          this.rightSlide1Translate = 'translate(0, -400%)';
          this.rightSlide2Translate = 'translate(0, -400%)';
          this.rightSlide3Translate = 'translate(0, -400%)';
          this.rightSlide4Translate = 'translate(0, -400%)';
          this.rightSlide5Translate = 'translate(0, -400%)';
          break;

        default:
          this.leftSlide1Translate = 'translate(0, 0)';
          this.leftSlide2Translate = 'translate(0, 0)';
          this.leftSlide3Translate = 'translate(0, 0)';
          this.leftSlide4Translate = 'translate(0, 0)';
          this.leftSlide5Translate = 'translate(0, 0)';

          this.rightSlide1Translate = 'translate(0, 0)';
          this.rightSlide2Translate = 'translate(0, 0)';
          this.rightSlide3Translate = 'translate(0, 0)';
          this.rightSlide4Translate = 'translate(0, 0)';
          this.rightSlide5Translate = 'translate(0, 0)';
          break;
      }
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_general_mixin__["a" /* default */]],

  name: 'bodyContainerComponent',

  watch: {
    windowWidth: function windowWidth(_windowWidth) {
      /* Get the mobile browser window width ratio to calculate the screen width  */
      var ratio = window.devicePixelRatio || 1;
      var screenWidth = _windowWidth / ratio;
      this.screenWidthSmall = screenWidth <= 850;

      this.setImageStyleBooks.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdBooks, this.screenWidthSmall, _windowWidth);

      this.setImageStyleCheers.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdCheers, this.screenWidthSmall, _windowWidth);

      this.setImageStyleOpenNight.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdOpenNight, this.screenWidthSmall, _windowWidth);

      this.setImageStyleSnacks.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdSnacks, this.screenWidthSmall, _windowWidth);

      this.setImageStyleSteamedBuns.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, true, this.imageIdSteamedBuns, this.screenWidthSmall, _windowWidth);
    }
  },

  created: function created() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);
    });
  },
  data: function data() {
    return {
      imageIdOpenNight: 'lollicup_open_night_1800_1200',
      imageIdCheers: 'lollicup_cheers_1810_1200',
      imageIdSnacks: 'lollicup_food_snacks_2619_1200',
      imageIdBooks: 'lollicup_entertainment_books_1200_1200',
      imageIdSteamedBuns: 'lollicup_food_steamed_buns_1810_1200',
      // Left slide initial configurations
      leftSlide1Translate: 'translate(0, 0)',
      leftSlide2Translate: 'translate(0, 0)',
      leftSlide3Translate: 'translate(0, 0)',
      leftSlide4Translate: 'translate(0, 0)',
      leftSlide5Translate: 'translate(0, 0)',
      // Right slide initial configurations
      rightSlide1Translate: 'translate(0, 0)',
      rightSlide2Translate: 'translate(0, 0)',
      rightSlide3Translate: 'translate(0, 0)',
      rightSlide4Translate: 'translate(0, 0)',
      rightSlide5Translate: 'translate(0, 0)',
      // Screen width size booleans
      screenWidthSmall: false,
      // Slider Image Component Styles
      setImageStyleBooks: {
        left: 0
      },
      setImageStyleCheers: {
        left: 0
      },
      setImageStyleOpenNight: {
        left: 0
      },
      setImageStyleSnacks: {
        left: 0
      },
      setImageStyleSteamedBuns: {
        left: 0
      },
      showModalLandingPopup: false,
      // Transform configurations
      slideTransformDuration: 'transform 1.5s',
      // Window dimensions
      windowHeight: 0,
      windowWidth: 0
    };
  },
  mounted: function mounted() {
    this.getWindowWidth();
    this.getWindowHeight();
  }
});

/***/ }),

/***/ "6gBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_component_vue__ = __webpack_require__("n2wD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d5012ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_component_vue__ = __webpack_require__("8ZRR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d5012ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ZRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu ld-background ld-right-slide ld-scroll-y"},[_c('v-layout',{staticClass:"px4",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"ld-menu-nav-container"},[_c('navigation-menu-component',{staticClass:"ld-scroll-none",on:{"onClickNav1":_vm.onClickNav1,"onClickNav2":_vm.onClickNav2,"onClickNav3":_vm.onClickNav3,"onClickNav4":_vm.onClickNav4}})],1),_vm._v(" "),_c('v-flex',{staticClass:"ld-menu-text-title-container",attrs:{"xs12":""}},[_c('div',{staticClass:"ld-menu-text-title mt-3 pl-3"},[_vm._v("Menu Page")])]),_vm._v(" "),_c('div',{staticClass:"ld-menu-slide-container"},[_c('div',{staticClass:"ld-menu-slide-carousel"},[_c('div',{staticClass:"ld-menu-slide",style:({'transform': _vm.slide1Translate, 'transition': _vm.slideTransformDuration})},[_c('v-layout',{staticClass:"mt-3 pl-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"ld-menu-text-header"},[_vm._v("Milk Tea")])]),_vm._v(" "),_vm._l((_vm.milkTeaFlavorColumns),function(flavor,index){return _c('v-flex',{key:index + '-' + flavor.flavor,staticClass:"ld-menu-text-container",class:_vm.getFlavorClass()},[_c('div',{staticClass:"ld-menu-text"},[_vm._v(_vm._s(flavor.flavor))]),_vm._v(" "),(flavor.dairy === true)?_c('div',{staticClass:"ld-menu-dairy"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(flavor.premium === true)?_c('div',{staticClass:"ld-menu-premium"},[_vm._v("P")]):_vm._e(),_vm._v(" "),(flavor.favorite === true)?_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")]):_vm._e()],1)}),_vm._v(" "),_c('v-flex',{staticClass:"ld-menu-text-container mt-1",attrs:{"xs12":""}},[_c('div',{staticClass:"ld-inline ld-menu-favorite"},[_vm._v("Favorite\n                "),_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")])],1),_vm._v(" "),_c('div',{staticClass:"ld-inline ld-menu-dairy mx-3"},[_vm._v("Contains Dairy (D)")]),_vm._v(" "),_c('div',{staticClass:"ld-inline ld-menu-premium"},[_vm._v("Premium (P)")])])],2)],1),_c('div',{staticClass:"ld-menu-slide",style:({'transform': _vm.slide3Translate, 'transition': _vm.slideTransformDuration})},[_c('v-layout',{staticClass:"mt-3 pl-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"ld-menu-text-header"},[_vm._v("Iced Tea")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"body-2 ld-menu-text ld-menu-regular my-1"},[_vm._v("Made with a choice of: Black, Jasmine, or Oolong\n                tea\n              ")])]),_vm._v(" "),_vm._l((_vm.icedTeaFlavorColumns),function(flavor,index){return _c('v-flex',{key:index + '-' + flavor.flavor,staticClass:"ld-menu-text-container",class:_vm.getFlavorClass()},[_c('div',{staticClass:"ld-menu-text"},[_vm._v(_vm._s(flavor.flavor))]),_vm._v(" "),(flavor.dairy === true)?_c('div',{staticClass:"ld-menu-dairy"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(flavor.premium === true)?_c('div',{staticClass:"ld-menu-premium"},[_vm._v("P")]):_vm._e(),_vm._v(" "),(flavor.favorite === true)?_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")]):_vm._e()],1)}),_vm._v(" "),_c('v-flex',{staticClass:"ld-menu-text-container mt-1",attrs:{"xs12":""}},[_c('div',{staticClass:"ld-inline ld-menu-favorite"},[_vm._v("Favorite\n                "),_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")])],1),_vm._v(" "),_c('div',{staticClass:"ld-inline ld-menu-dairy mx-3"},[_vm._v("Contains Dairy (D)")]),_vm._v(" "),_c('div',{staticClass:"ld-inline ld-menu-premium"},[_vm._v("Premium (P)")])])],2)],1),_c('div',{staticClass:"ld-menu-slide",style:({'transform': _vm.slide2Translate, 'transition': _vm.slideTransformDuration})},[_c('v-layout',{staticClass:"mt-3 pl-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"ld-menu-text-header"},[_vm._v("Snow Bubble or Slush")])]),_vm._v(" "),_vm._l((_vm.slushAndSnowFlavorColumns),function(flavor,index){return _c('v-flex',{key:index + '-' + flavor.flavor,staticClass:"ld-menu-text-container",class:_vm.getFlavorClass()},[_c('div',{staticClass:"ld-menu-text"},[_vm._v(_vm._s(flavor.flavor))]),_vm._v(" "),(flavor.dairy === true)?_c('div',{staticClass:"ld-menu-dairy"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(flavor.premium === true)?_c('div',{staticClass:"ld-menu-premium"},[_vm._v("P")]):_vm._e(),_vm._v(" "),(flavor.favorite === true)?_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")]):_vm._e()],1)}),_vm._v(" "),_c('v-flex',{staticClass:"ld-menu-text-container mt-1",attrs:{"xs12":""}},[_c('div',{staticClass:"ld-inline ld-menu-favorite"},[_vm._v("Favorite\n              "),_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")])],1),_vm._v(" "),_c('div',{staticClass:"ld-inline ld-menu-dairy mx-3"},[_vm._v("Contains Dairy (D)")]),_vm._v(" "),_c('div',{staticClass:"ld-inline ld-menu-premium"},[_vm._v("Premium (P)")])])],2)],1),_c('div',{staticClass:"ld-menu-slide",style:({'transform': _vm.slide4Translate, 'transition': _vm.slideTransformDuration})},[_c('v-layout',{staticClass:"mt-3 pl-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"ld-menu-text-header"},[_vm._v("Add-ins")])]),_vm._v(" "),_c('v-flex',{staticClass:"ld-menu-text-container",attrs:{"xs12":""}},[_c('div',{staticClass:"ld-menu-text-header-2 mt-2"},[_vm._v("Boba "),_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")])],1),_vm._v(" "),_c('div',{staticClass:"ld-menu-text-regular my-1"},[_vm._v("Also known as “tapioca balls” or “pearls”, boba originated in\n                Taiwan and are made of the starch derived from cassava root. When prepared perfectly, boba becomes\n                sweet, chewy, and translucent with a gummy bear-like texture.\n              ")])]),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"ld-menu-text-header-2 mt-2"},[_vm._v("Poppers")]),_vm._v(" "),_c('div',{staticClass:"ld-menu-text-regular my-1"},[_vm._v("Originating in Asia, popping pearls (also known as “popping boba”\n                or “bursting boba”) are a beverage sensation trending in mainstream Europe. Each popping pearl is\n                about 3/8” in diameter and bursts with flavorful fruit juices when bitten into.\n              ")])]),_vm._v(" "),_vm._l((_vm.popperFlavorColumns),function(flavor,index){return _c('v-flex',{key:index + '-' + flavor.flavor,staticClass:"ld-menu-text-container",class:_vm.getFlavorClass()},[_c('div',{staticClass:"ld-menu-text"},[_vm._v(_vm._s(flavor.flavor))]),_vm._v(" "),(flavor.dairy === true)?_c('div',{staticClass:"ld-menu-dairy"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(flavor.premium === true)?_c('div',{staticClass:"ld-menu-premium"},[_vm._v("P")]):_vm._e(),_vm._v(" "),(flavor.favorite === true)?_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")]):_vm._e()],1)}),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"ld-menu-text-header-2 mt-2"},[_vm._v("Jellies")]),_vm._v(" "),_c('div',{staticClass:"ld-menu-text-regular my-1"},[_vm._v("Jelly and other toppings add extra fun and flavor into your\n                beverage. Whether it's coffee jelly in your milk tea, three color jelly or an assortment of jellies\n                in your slush, or mango jelly in your fruit tea, Lollicup offers a variety of jellies that will\n                sweeten any beverage.\n              ")])]),_vm._v(" "),_vm._l((_vm.jellyFlavorColumns),function(flavor,index){return _c('v-flex',{key:index + '-' + flavor.flavor,staticClass:"ld-menu-text-container",class:_vm.getFlavorClass()},[_c('div',{staticClass:"ld-menu-text"},[_vm._v(_vm._s(flavor.flavor))]),_vm._v(" "),(flavor.dairy === true)?_c('div',{staticClass:"ld-menu-dairy"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(flavor.premium === true)?_c('div',{staticClass:"ld-menu-premium"},[_vm._v("P")]):_vm._e(),_vm._v(" "),(flavor.favorite === true)?_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")]):_vm._e()],1)}),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"ld-menu-text-header-2 mt-2"},[_vm._v("Pudding")]),_vm._v(" "),_c('div',{staticClass:"ld-menu-text-regular my-1"},[_vm._v("Flavored pudding is a flan textured custard that can be added into\n                any beverage. Enjoy your favorite milk tea with one or a combination of chocolate, eggnog, taro,\n                milk, or all four great pudding flavors.\n              ")])]),_vm._v(" "),_vm._l((_vm.puddingFlavorColumns),function(flavor,index){return _c('v-flex',{key:index + '-' + flavor.flavor,staticClass:"ld-menu-text-container",class:_vm.getFlavorClass()},[_c('div',{staticClass:"ld-menu-text"},[_vm._v(_vm._s(flavor.flavor))]),_vm._v(" "),(flavor.dairy === true)?_c('div',{staticClass:"ld-menu-dairy"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(flavor.premium === true)?_c('div',{staticClass:"ld-menu-premium"},[_vm._v("P")]):_vm._e(),_vm._v(" "),(flavor.favorite === true)?_c('v-icon',{staticClass:"ld-menu-favorite"},[_vm._v("favorite")]):_vm._e()],1)})],2)],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8bnk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"ld-nav-bar ld-nav-bar-menu"},[_c('v-flex',{staticClass:"xs3 ld-inline-block"},[_c('div',{staticClass:"ld-nav-bar-item",attrs:{"slot":"activator"},on:{"click":_vm.onClickNav1},slot:"activator"},[_c('div',{staticClass:"ld-nav-text"},[_vm._v("Milk Tea")])])]),_vm._v(" "),_c('v-flex',{staticClass:"xs3 ld-inline-block"},[_c('div',{staticClass:"ld-nav-bar-item",attrs:{"slot":"activator"},on:{"click":_vm.onClickNav2},slot:"activator"},[_c('div',{staticClass:"ld-nav-text"},[_vm._v("Iced Tea")])])]),_vm._v(" "),_c('v-flex',{staticClass:"xs3 ld-inline-block"},[_c('div',{staticClass:"ld-nav-bar-item",attrs:{"slot":"activator"},on:{"click":_vm.onClickNav3},slot:"activator"},[_c('div',{staticClass:"ld-nav-text"},[_vm._v("Slush - Snow")])])]),_vm._v(" "),_c('v-flex',{staticClass:"xs3 ld-inline-block"},[_c('div',{staticClass:"ld-nav-bar-item",attrs:{"slot":"activator"},on:{"click":_vm.onClickNav4},slot:"activator"},[_c('div',{staticClass:"ld-nav-text"},[_vm._v("Add-ins")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8kY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

var opts = {};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a(opts));

/***/ }),

/***/ "E28O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_slide_component_vue__ = __webpack_require__("v3lv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91ea5bd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_slide_component_vue__ = __webpack_require__("y4XA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_slide_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91ea5bd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_slide_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fova":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    onClickNav1: function onClickNav1(element) {
      this.$emit('onClickNav1', element);
    },

    onClickNav2: function onClickNav2(element) {
      this.$emit('onClickNav2', element);
    },

    onClickNav3: function onClickNav3(element) {
      this.$emit('onClickNav3', element);
    },

    onClickNav4: function onClickNav4(element) {
      this.$emit('onClickNav4', element);
    },

    onClickNav5: function onClickNav5(element) {
      this.$emit('onClickNav5', element);
    }
  },

  name: 'navigationComponentMain',

  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "GZxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery ld-background ld-right-slide ld-scroll-y"},[_c('gallery',{attrs:{"images":_vm.images,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},_vm._l((_vm.images),function(image,imageIndex){return _c('img',{key:imageIndex,staticClass:"image",attrs:{"src":image},on:{"click":function($event){return _vm.selectForIndex(imageIndex)}}})}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gxu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ld-nav-bar ld-nav-bar-main"},[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"ld-nav-bar-item",on:{"click":_vm.onClickNav1}},on),[_c('v-icon',[_vm._v("home")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Lollicup Denver")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"ld-nav-bar-item",on:{"click":_vm.onClickNav2}},on),[_c('v-icon',[_vm._v("group")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("About")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"ld-nav-bar-item",on:{"click":_vm.onClickNav3}},on),[_c('v-icon',[_vm._v("local_drink")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Menu")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"ld-nav-bar-item",on:{"click":_vm.onClickNav4}},on),[_c('v-icon',[_vm._v("photo_camera")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Gallery")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"ld-nav-bar-item",on:{"click":_vm.onClickNav5}},on),[_c('v-icon',[_vm._v("location_on")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Contact")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IXfC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JcBq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: [{
    dairy: false,
    favorite: false,
    flavor: 'Aloe',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Coffee',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Green Apple',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Lychee',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Mango',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Passion Fruit',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Strawberry',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Three Color',
    premium: false
  }]
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dfb31d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ntaX");
function injectStyle (ssrContext) {
  __webpack_require__("IXfC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5dfb31d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dfb31d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M959":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about ld-background ld-right-slide ld-scroll-y"},[_c('v-layout',{staticClass:"ld-height-100 px-4",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"ld-height-50 pt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"ld-height-100 text-xs-center"},[_c('iframe',{attrs:{"width":"90%","height":"100%","src":"https://www.youtube.com/embed/GRNFoB2rWzo","frameborder":"0","allowfullscreen":""}})])]),_vm._v(" "),_c('v-layout',{staticClass:"ld-height-50",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('h3',{staticClass:"ld-about-text-title",class:{'pr-5' : _vm.screenWidthSmall}},[_vm._v("\n          What is Lollicup Denver?\n        ")]),_vm._v(" "),_c('div',{staticClass:"ld-about-text"},[_vm._v("\n          Boba, originally from Taiwan, is used in everything from smoothies to tea. There, a business called Lollicup was created\n          to specialize in drinks that go well with boba and other delicious add-ins, such as jelli, and pudding. It was a very\n          popular drink for children and became a common after-school hangout, and soon, Lollicup took off, opening up in places\n          around the world. Lollicup Denver opened in April of 2003, and since then, it has grown as a company to be a busy hot\n          spot in Denver and has helped to make Boba more popular in Colorado, serving hundreds of drink combinations with more\n          than 20 different add-ins. Check us out and join the Lollicup Denver family!\n        ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MEOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: [{
    dairy: false,
    favorite: true,
    flavor: 'Royal',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Almond',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Barley',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Black',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Cappuccino',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Chocolate',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Coconut',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Coffee',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Ginger',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Honey',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Honeydew',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Ice Coffee',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Jasmine',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Lavender',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Pumpkin',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Sesame',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Taro',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Thai',
    premium: false
  }]
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_vuetify__ = __webpack_require__("8kY9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__plugins_vuetify__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  vuetify: __WEBPACK_IMPORTED_MODULE_2__plugins_vuetify__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_0__App_vue__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),

/***/ "O17j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_body_container_component_vue__ = __webpack_require__("5fxe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16daace4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_body_container_component_vue__ = __webpack_require__("uCBZ");
function injectStyle (ssrContext) {
  __webpack_require__("+6RT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16daace4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_body_container_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16daace4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_body_container_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OCDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModalLandingPopup',

  created: function created() {
    this.dialog = true;
  },
  data: function data() {
    return {
      dialog: false,
      dialogHoursOfOperation: [{
        dayOfWeek: 'Monday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Tuesday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Wednesday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Thursday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Friday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Saturday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Sunday',
        hours: '12:00 P.M. - 8:00 P.M.'
      }],
      showAnnouncement: true
    };
  }
});

/***/ }),

/***/ "Pqsl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  siteMediaLoadQuality: 'mq'
});

/***/ }),

/***/ "TL4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contactComponent',

  props: ['screenWidthSmall'],

  data: function data() {
    return {
      hoursOfOperationAdjusted: [{
        dayOfWeek: 'Monday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Tuesday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Wednesday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Thursday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Friday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Saturday',
        hours: '11:00 A.M. - 8:00 P.M.'
      }, {
        dayOfWeek: 'Sunday',
        hours: '12:00 P.M. - 8:00 P.M.'
      }],
      hoursOfOperationNormal: [{
        dayOfWeek: 'Monday',
        hours: '11:00 A.M. - 9:00 P.M.'
      }, {
        dayOfWeek: 'Tuesday',
        hours: '11:00 A.M. - 9:00 P.M.'
      }, {
        dayOfWeek: 'Wednesday',
        hours: '11:00 A.M. - 9:00 P.M.'
      }, {
        dayOfWeek: 'Thursday',
        hours: '11:00 A.M. - 9:00 P.M.'
      }, {
        dayOfWeek: 'Friday',
        hours: '11:00 A.M. - 10:00 P.M.'
      }, {
        dayOfWeek: 'Saturday',
        hours: '11:00 A.M. - 10:00 P.M.'
      }, {
        dayOfWeek: 'Sunday',
        hours: '12:00 P.M. - 8:00 P.M.'
      }],
      showHoursOfOperationAdjusted: false
    };
  }
});

/***/ }),

/***/ "Xg6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_menu_component_vue__ = __webpack_require__("4kVZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1997456c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_menu_component_vue__ = __webpack_require__("8bnk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_menu_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1997456c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_menu_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bw+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e5cf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: [{
    dairy: false,
    favorite: false,
    flavor: 'Chocolate',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Egg Nog',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Milk',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Taro',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Four Pudding',
    premium: false
  }]
});

/***/ }),

/***/ "er3Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_component_vue__ = __webpack_require__("TL4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f03dc33c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_component_vue__ = __webpack_require__("sPtb");
function injectStyle (ssrContext) {
  __webpack_require__("g1WZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f03dc33c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f03dc33c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f+Mp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gallery_component_vue__ = __webpack_require__("f0c1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f81bd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gallery_component_vue__ = __webpack_require__("GZxk");
function injectStyle (ssrContext) {
  __webpack_require__("rc8G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9f81bd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gallery_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f81bd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gallery_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f0c1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_general_mixin__ = __webpack_require__("3rSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_gallery__ = __webpack_require__("I4KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_gallery__);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'gallery': __WEBPACK_IMPORTED_MODULE_1_vue_gallery___default.a
  },

  methods: {
    selectForIndex: function selectForIndex(index) {
      this.index = index;
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_general_mixin__["a" /* default */]],

  name: 'galleryComponent',

  props: ['screenWidthSmall'],

  data: function data() {
    return {
      index: null,
      images: [this.getGalleryImagePath('lollicup_gallery_01_1200w.jpg'), this.getGalleryImagePath('lollicup_gallery_03_1200w.jpg'), this.getGalleryImagePath('lollicup_gallery_04_1200w.jpg')]
    };
  }
});

/***/ }),

/***/ "fCdN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_utils__ = __webpack_require__("mF0L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_general_mixin__ = __webpack_require__("3rSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_slide_component_vue__ = __webpack_require__("E28O");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    NavSlideComponent: __WEBPACK_IMPORTED_MODULE_2__nav_slide_component_vue__["a" /* default */]
  },

  methods: {
    /**
     * imageMountedLollicupFoodDrinks will listen for the image mounted event from the nav slide component, then get
     * and set the image style left offset for the Lollicup food drinks image. This functionality was created because
     * the width of the image may not be available on any of the built in Vue instance functions, due to loading
     * delays.
     */
    imageMountedLollicupFoodDrinks: function imageMountedLollicupFoodDrinks() {
      this.setImageStyleDrinks.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, false, this.imageIdDrinks, this.screenWidthSmall, this.windowWidth);
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_general_mixin__["a" /* default */]],

  name: 'homeComponent',

  props: ['screenWidthSmall', 'windowHeight', 'windowWidth'],

  watch: {
    windowWidth: function windowWidth(_windowWidth) {
      this.setImageStyleDrinks.left = __WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* getImageStyleLeft */](document, false, this.imageIdDrinks, this.screenWidthSmall, _windowWidth);
    }
  },

  data: function data() {
    return {
      imageIdDrinks: 'lollicupFoodDrinks2310x1200',
      setImageStyleDrinks: {
        left: 0
      }
    };
  }
});

/***/ }),

/***/ "g1WZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iuAG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jrSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_main_component_vue__ = __webpack_require__("Fova");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bd2df74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_main_component_vue__ = __webpack_require__("Gxu6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_main_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bd2df74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_main_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mF0L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHtmlEm;
/* harmony export (immutable) */ __webpack_exports__["b"] = getImageStyleLeft;
/* harmony export (immutable) */ __webpack_exports__["c"] = getImageWidthById;
/* harmony export (immutable) */ __webpack_exports__["d"] = getWindowHeight;
/* harmony export (immutable) */ __webpack_exports__["e"] = getWindowWidth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("mF0L");


/**
 * getHtmlEm will return the em value of the document HTML.
 * @returns {Number|number}
 */
function getHtmlEm(document) {
  return parseFloat(getComputedStyle(document.querySelector('html'))['font-size']) || 0;
}

/**
 * getImageStyleLeft will return the offset value for the CSS style 'left' to allow the image to stay the
 * image to stay centered in the viewport, without setting the image to a width equal to 100% of it's parent
 * container.
 * @returns {string}
 */
function getImageStyleLeft(document, hasNavBar, imageId, screenWidthSmall, windowWidth) {
  var HTML_EM = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* getHtmlEm */](document);
  var NAV_BAR_WIDTH = HTML_EM * 5;
  var IMAGE_WIDTH = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* getImageWidthById */](document, imageId);
  var WINDOW_WIDTH = windowWidth || 0;
  var offset = 0;
  var viewport = 0;

  // If the window is large
  if (!screenWidthSmall) {
    // View port is the window width minus nav bar width divided by two (split sliders)
    viewport = (WINDOW_WIDTH - NAV_BAR_WIDTH) / 2;
    if (hasNavBar) {
      // If the this image is next to the nav bar, add the nav bar width to the offset to start the offset at the
      // appropriate x index.
      offset = (viewport - IMAGE_WIDTH) / 2 + NAV_BAR_WIDTH;
    } else {
      // 'OverflowX' is set to hidden, the offset is only going to be to the left. Divide the pixel difference by
      // two and set that to the 'left' style, the other half will overflow to the right. Since this image is on
      // the right, do not add the nav bar width to the 'left' set value, since the nav bar is not part of the left
      // slider. Also, we should only be doing an offset if the image is larger than the viewport, the offset
      // should return a negative (left: -...), and there will always be an offset if the image is larger than the
      // viewport.
      offset = (viewport - IMAGE_WIDTH) / 2;
    }
  } else {
    viewport = WINDOW_WIDTH - NAV_BAR_WIDTH;
    offset = (viewport - IMAGE_WIDTH) / 2 + NAV_BAR_WIDTH;
  }
  offset = offset < 0 ? offset : offset - NAV_BAR_WIDTH;

  return offset.toString() + 'px';
}

/**
 * getImageWidthById will return the width of the image on the DOM return by the ID provided.
 * @returns {Number|number}
 */
function getImageWidthById(document, imageId) {
  return document.getElementById(imageId).offsetWidth || 0;
}

/**
 * getWindowHeight will get the browser view window height.
 * @returns {Number|number}
 */
function getWindowHeight(document) {
  return document.documentElement.clientHeight;
}

/**
 * getWindowWidth will get the browser view window width.
 * @returns {Number|number}
 */
function getWindowWidth(document) {
  return document.documentElement.clientWidth;
}

/***/ }),

/***/ "n2wD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_iced_tea_flavors__ = __webpack_require__("5+Wq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_jelly_flavors__ = __webpack_require__("JcBq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_milk_tea_flavors__ = __webpack_require__("MEOn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_menu_component_vue__ = __webpack_require__("Xg6U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_popper_flavors__ = __webpack_require__("nndR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_pudding_flavors__ = __webpack_require__("e5cf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__js_slush_and_snow_flavors__ = __webpack_require__("yrLN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    NavigationMenuComponent: __WEBPACK_IMPORTED_MODULE_3__navigation_menu_component_vue__["a" /* default */]
  },

  methods: {
    getFlavorClass: function getFlavorClass() {
      var returnClass = void 0;

      if (this.screenWidthSmall) {
        returnClass = ' xs6';
      } else {
        returnClass = ' xs4';
      }
      return returnClass;
    },

    getFlavorColumns: function getFlavorColumns(flavors, numberOfColumns) {
      var buildColumns = {};
      var i = void 0;
      var ii = void 0;
      var returnBuildColumns = [];
      var FLAVORS = flavors || [];
      var TOTAL_COLUMNS = numberOfColumns;
      var TOTAL_FLAVORS = FLAVORS.length;
      var TOTAL_PER_COLUMN = Math.floor(TOTAL_FLAVORS / TOTAL_COLUMNS);
      var TOTAL_LAST_COLUMNS = TOTAL_FLAVORS % TOTAL_COLUMNS;
      var IS_OFFSET = TOTAL_LAST_COLUMNS > 0;
      var offset = void 0;

      // Make sure the child objects exist to set data into
      for (i = 0; i < TOTAL_COLUMNS; i++) {
        buildColumns[i] = {};
      }

      for (i = 0; i < TOTAL_PER_COLUMN; i++) {
        // Reset the offset on the start of each row.
        offset = 0;
        for (ii = 0; ii < TOTAL_COLUMNS; ii++) {
          if (typeof FLAVORS[i + (TOTAL_PER_COLUMN * ii + offset)] !== 'undefined') {
            buildColumns[ii][i] = FLAVORS[i + (TOTAL_PER_COLUMN * ii + offset)];
            // Offset starts at 0 to not offset the first column. If 'IS_OFFSET' is true, then there is an offset to
            // all columns after the first. Only increment up to one less than the 'TOTAL_LAST_COLUMNS' to offset
            // each incremented column by the last incremented offset value. Total offset will increase by the number
            // of cells shifted. If no more cells shift, the offset will not increment. Offset is when there is a
            // difference in number of flavors per column, 'offset = (flavors % columns > 0)'. Makes sense right?
            if (IS_OFFSET && offset < TOTAL_LAST_COLUMNS) {
              ++offset;
            }
          } else {
            // In order to fill the empty space on the DOM to represent the offset, add an empty element to the
            // 'buildColumns' array when an undefined is found during iterations.
            buildColumns[ii][i] = '';
          }
        }
      }

      // Total columns is the number of columns that will have an extra element after the final iteration of the
      // above for-loop. This was implemented to prevent the columns from overlapping values.
      if (TOTAL_LAST_COLUMNS > 0) {
        // Reset the offset for the final row
        offset = 0;
        // 'i' is already incremented from the previous for-loop, use 'i' at it's current value to get the final
        // elements from the 'FLAVORS' array.
        for (ii = 0; ii < TOTAL_LAST_COLUMNS; ii++) {
          if (typeof FLAVORS[i + (TOTAL_PER_COLUMN * ii + offset)] !== 'undefined') {
            buildColumns[ii][i] = FLAVORS[i + (TOTAL_PER_COLUMN * ii + offset)];
            // Offset starts at 0 to not offset the first column. If 'IS_OFFSET' is true, then there is an offset to
            // all columns after the first. Only increment up to one less than the 'TOTAL_LAST_COLUMNS' to offset
            // each incremented column by the last incremented offset value. Total offset will increase by the number
            // of cells shifted. If no more cells shift, the offset will not increment. Offset is when there is a
            // difference in number of flavors per column, 'offset = (flavors % columns > 0)'. Makes sense right?
            if (IS_OFFSET && offset < TOTAL_LAST_COLUMNS) {
              ++offset;
            }
          } else {
            // In order to offset the empty space, add an empty element to the 'buildColumns' array.
            buildColumns[ii][i] = '';
          }
        }
      }

      // Rebuild the final array that will be used as the v-for array to build the slush and snow menu.
      for (i = 0; i <= TOTAL_PER_COLUMN; i++) {
        for (ii = 0; ii < TOTAL_COLUMNS; ii++) {
          if (typeof buildColumns[ii][i] !== 'undefined') {
            returnBuildColumns.push(buildColumns[ii][i]);
          }
        }
      }

      // Total last columns is the number of columns that will have an extra element after the final iteration of the
      // above for-loop.
      if (TOTAL_LAST_COLUMNS > 0) {
        // 'i' is already incremented from the previous for-loop, use 'i' at it's current value to get the final
        // elements from the 'buildColumns' array.
        for (ii = 0; ii < TOTAL_LAST_COLUMNS; ii++) {
          if (typeof buildColumns[ii][i] !== 'undefined') {
            returnBuildColumns.push(buildColumns[ii][i]);
          }
        }
      }
      return returnBuildColumns;
    },

    /**
     * onClickNav1 will listen for the click event of the first navigation button, then call the
     * 'transitionSlides' to transition the left and right slides.
     */
    onClickNav1: function onClickNav1() {
      this.transitionSlides(1);
    },

    /**
     * onClickNav2 will listen for the click event of the second navigation button, then call the
     * 'transitionSlides' to transition the left and right slides.
     */
    onClickNav2: function onClickNav2() {
      this.transitionSlides(2);
    },

    /**
     * onClickNav3 will listen for the click event of the third navigation button, then call the
     * 'transitionSlides' to transition the left and right slides.
     */
    onClickNav3: function onClickNav3() {
      this.transitionSlides(3);
    },

    /**
     * onClickNav4 will listen for the click event of the fourth navigation button, then call the
     * 'transitionSlides' to transition the left and right slides.
     */
    onClickNav4: function onClickNav4() {
      this.transitionSlides(4);
    },

    /**
     * transitionSlides will set the slide transition values appropriately, determined by the argument provided.
     * @param navDestination - integer - the navigation button clicked.
     */
    transitionSlides: function transitionSlides(navDestination) {
      switch (navDestination) {
        case 1:
          this.slide1Translate = 'translate(0, 0)';
          this.slide2Translate = 'translate(0, 0)';
          this.slide3Translate = 'translate(0, 0)';
          this.slide4Translate = 'translate(0, 0)';
          break;

        case 2:
          this.slide1Translate = 'translate(-100%, 0)';
          this.slide2Translate = 'translate(-100%, 0)';
          this.slide3Translate = 'translate(-100%, 0)';
          this.slide4Translate = 'translate(-100%, 0)';
          break;

        case 3:
          this.slide1Translate = 'translate(-200%, 0)';
          this.slide2Translate = 'translate(-200%, 0)';
          this.slide3Translate = 'translate(-200%, 0)';
          this.slide4Translate = 'translate(-200%, 0)';
          break;

        case 4:
          this.slide1Translate = 'translate(-300%, 0)';
          this.slide2Translate = 'translate(-300%, 0)';
          this.slide3Translate = 'translate(-300%, 0)';
          this.slide4Translate = 'translate(-300%, 0)';
          break;

        default:
          this.slide1Translate = 'translate(0, 0)';
          this.slide2Translate = 'translate(0, 0)';
          this.slide3Translate = 'translate(0, 0)';
          this.slide4Translate = 'translate(0, 0)';
          break;
      }
    }
  },

  name: 'menuComponent',

  props: ['screenWidthSmall'],

  watch: {
    screenWidthSmall: function screenWidthSmall(value) {
      var NUMBER_OF_COLUMNS = value ? 2 : 3;
      this.icedTeaFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_0__js_iced_tea_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
      this.jellyFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_1__js_jelly_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
      this.milkTeaFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_2__js_milk_tea_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
      this.popperFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_4__js_popper_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
      this.puddingFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_5__js_pudding_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
      this.slushAndSnowFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_6__js_slush_and_snow_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
    }
  },

  data: function data() {
    return {
      icedTeaFlavorColumns: [],
      jellyFlavorColumns: [],
      milkTeaFlavorColumns: [],
      popperFlavorColumns: [],
      puddingFlavorColumns: [],
      slushAndSnowFlavorColumns: [],
      // Left slide initial configurations
      slide1Translate: 'translate(0, 0)',
      slide2Translate: 'translate(0, 0)',
      slide3Translate: 'translate(0, 0)',
      slide4Translate: 'translate(0, 0)',
      // Transform configurations
      slideTransformDuration: 'transform 1.5s'
    };
  },
  mounted: function mounted() {
    var NUMBER_OF_COLUMNS = this.screenWidthSmall ? 2 : 3;
    this.icedTeaFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_0__js_iced_tea_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
    this.jellyFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_1__js_jelly_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
    this.milkTeaFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_2__js_milk_tea_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
    this.popperFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_4__js_popper_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
    this.puddingFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_5__js_pudding_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
    this.slushAndSnowFlavorColumns = this.getFlavorColumns(__WEBPACK_IMPORTED_MODULE_6__js_slush_and_snow_flavors__["a" /* default */].data, NUMBER_OF_COLUMNS);
  }
});

/***/ }),

/***/ "nndR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: [{
    dairy: false,
    favorite: false,
    flavor: 'Green Apple',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Lychee',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Strawberry',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Yogurt',
    premium: false
  }]
});

/***/ }),

/***/ "ntaX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ld-app-container",attrs:{"id":"app"}},[_c('v-app',{staticClass:"ld-app"},[_c('v-content',{staticClass:"ld-content"},[_c('body-container-component')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oxG6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rc8G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sPtb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact ld-background ld-left-slide ld-scroll-y"},[_c('div',{staticClass:"ld-height-100 px-4"},[_c('v-row',{staticClass:"ld-height-50 pt-3"},[_c('v-col',{attrs:{"xs":"12"}},[_c('div',{staticClass:"ld-height-100 text-xs-center",class:{'pr-4' : _vm.screenWidthSmall}},[_c('iframe',{staticStyle:{"user-select":"text"},attrs:{"width":"100%","height":"100%","frameborder":"0","scrolling":"no","marginheight":"0","marginwidth":"0","src":"https://maps.google.com/maps?f=q&source=s_q&hl=en&geocode=&q=lollicup+denver&aq=&sll=38.997934,-105.550567&sspn=5.710579,6.580811&t=h&ie=UTF8&hq=lollicup+denver&ll=39.687814,-104.941892&spn=0.011047,0.014291&z=16&iwloc=A&cid=17393576260634331111&output=embed"}})])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"xs":"12"}},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("\n            Contact Information:\n          ")])]),_vm._v(" "),_c('div',{staticClass:"ld-contact-text"},[_vm._v("\n          Lollicup Denver Tea Zone\n        ")]),_vm._v(" "),_c('div',{staticClass:"ld-contact-text"},[_vm._v("\n          1589 S. Colorado Blvd.\n        ")]),_vm._v(" "),_c('div',{staticClass:"ld-contact-text"},[_vm._v("\n          Denver, CO 80222\n        ")]),_vm._v(" "),_c('div',{staticClass:"ld-contact-text"},[_vm._v("\n          Phone: 303-504-6022\n        ")])])],1),_vm._v(" "),(_vm.showHoursOfOperationAdjusted)?_c('v-row',[_c('v-col',{attrs:{"xs":"12"}},[_c('v-row',[_c('v-col',{attrs:{"xs":"12"}},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Hours of Operation (adjusted):")])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"font-italic"},[_vm._v("(Adjusted hours due to COVID-19)")])])])],1),_vm._v(" "),_vm._l((_vm.hoursOfOperationAdjusted),function(item){return _c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","xs":"4","sm":"3","lg":"2"}},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.dayOfWeek))])])]),_vm._v(" "),_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","xs":"8","sm":"9","lg":"10"}},[_c('div',[_c('span',[_vm._v(_vm._s(item.hours))])])])],1)})],2)],1):_vm._e(),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"xs":"12"}},[_c('v-row',[_c('v-col',{attrs:{"xs":"12"}},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Summer Hours of Operation:")])])])],1),_vm._v(" "),_vm._l((_vm.hoursOfOperationNormal),function(item){return _c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","xs":"4","sm":"3","lg":"2"}},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.dayOfWeek))])])]),_vm._v(" "),_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","xs":"8","sm":"9","lg":"10"}},[_c('div',[_c('span',[_vm._v(_vm._s(item.hours))])])])],1)})],2)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uCBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey darken-4 ld-container",attrs:{"fluid":""}},[_c('v-layout',{staticClass:"ld-layout",attrs:{"row":""}},[_c('v-flex',{staticClass:"ld-navigation"},[_c('navigation-main-component',{on:{"onClickNav1":_vm.onClickNav1,"onClickNav2":_vm.onClickNav2,"onClickNav3":_vm.onClickNav3,"onClickNav4":_vm.onClickNav4,"onClickNav5":_vm.onClickNav5}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.screenWidthSmall),expression:"!screenWidthSmall"}],staticClass:"ld-left-slide-container"},[_c('div',{staticClass:"ld-logo"},[_c('img',{attrs:{"src":_vm.getComponentImagePath('lollicup_logo_transparency_400_201.png')}})]),_vm._v(" "),_c('div',{staticClass:"ld-left-slide-carousel"},[_c('nav-slide-component',{style:({
            'bottom': '400%',
            'overflow': 'hidden',
            'transform': _vm.leftSlide1Translate,
            'transition': _vm.slideTransformDuration
          }),attrs:{"setClassContainer":'ld-left-slide ld-scroll-none',"setClassImage":'ld-left-slide-image',"setIdImage":_vm.imageIdOpenNight,"setSourceImage":_vm.getComponentImagePath('lollicup_open_night_1800_1200.jpg'),"setStyleContainer":'',"setStyleImage":_vm.setImageStyleOpenNight},on:{"imageMounted":_vm.imageMountedLollicupOpenNight}}),_vm._v(" "),_c('nav-slide-component',{style:({
            'bottom': '400%',
            'overflow': 'hidden',
            'transform': _vm.leftSlide2Translate,
            'transition': _vm.slideTransformDuration
          }),attrs:{"setClassContainer":'ld-left-slide ld-scroll-none',"setClassImage":'ld-left-slide-image',"setIdImage":_vm.imageIdCheers,"setSourceImage":_vm.getComponentImagePath('lollicup_cheers_1200_1200.JPG'),"setStyleContainer":'',"setStyleImage":_vm.setImageStyleCheers},on:{"imageMounted":_vm.imageMountedLollicupCheers}}),_vm._v(" "),_c('nav-slide-component',{style:({
            'bottom': '400%',
            'overflow': 'hidden',
            'transform': _vm.leftSlide3Translate,
            'transition': _vm.slideTransformDuration
          }),attrs:{"setClassContainer":'ld-left-slide ld-scroll-none',"setClassImage":'ld-left-slide-image',"setIdImage":_vm.imageIdSnacks,"setSourceImage":_vm.getComponentImagePath('lollicup_food_snacks_1812_1200.jpg'),"setStyleContainer":'',"setStyleImage":_vm.setImageStyleSnacks},on:{"imageMounted":_vm.imageMountedLollicupSnacks}}),_vm._v(" "),_c('nav-slide-component',{style:({
            'bottom': '400%',
            'overflow': 'hidden',
            'transform': _vm.leftSlide4Translate,
            'transition': _vm.slideTransformDuration
          }),attrs:{"setClassContainer":'ld-left-slide ld-scroll-none',"setClassImage":'ld-left-slide-image',"setIdImage":_vm.imageIdBooks,"setSourceImage":_vm.getComponentImagePath('lollicup_entertainment_books_1812_1200.jpg'),"setStyleContainer":'',"setStyleImage":_vm.setImageStyleBooks},on:{"imageMounted":_vm.imageMountedLollicupBooks}}),_vm._v(" "),_c('nav-slide-component',{style:({
            'bottom': '400%',
            'overflow': 'hidden',
            'transform': _vm.leftSlide5Translate,
            'transition': _vm.slideTransformDuration
          }),attrs:{"setClassContainer":'ld-left-slide ld-scroll-none',"setClassImage":'ld-left-slide-image',"setIdImage":_vm.imageIdSteamedBuns,"setSourceImage":_vm.getComponentImagePath('lollicup_store_front_decal_1200_1200.jpg'),"setStyleContainer":'',"setStyleImage":_vm.setImageStyleSteamedBuns},on:{"imageMounted":_vm.imageMountedLollicupSteamedBuns}})],1)]),_vm._v(" "),_c('v-flex',{staticClass:"ld-right-slide-container",class:{ 'ld-right-slide-width-half' : !_vm.screenWidthSmall,
    'ld-right-slide-width-full' : _vm.screenWidthSmall}},[_c('div',{staticClass:"ld-right-slide-carousel"},[_c('home-component',{style:({bottom: '0', transition: _vm.slideTransformDuration, transform: _vm.rightSlide1Translate}),attrs:{"screenWidthSmall":_vm.screenWidthSmall,"windowHeight":_vm.windowHeight,"windowWidth":_vm.windowWidth}}),_vm._v(" "),_c('about-component',{style:({bottom: '-100%', transition: _vm.slideTransformDuration, transform: _vm.rightSlide2Translate}),attrs:{"screenWidthSmall":_vm.screenWidthSmall}}),_vm._v(" "),_c('menu-component',{style:({bottom: '-200%', transition: _vm.slideTransformDuration, transform: _vm.rightSlide3Translate}),attrs:{"screenWidthSmall":_vm.screenWidthSmall}}),_vm._v(" "),_c('gallery-component',{style:({bottom: '-300%', transition: _vm.slideTransformDuration, transform: _vm.rightSlide4Translate}),attrs:{"screenWidthSmall":_vm.screenWidthSmall}}),_vm._v(" "),_c('contact-component',{style:({bottom: '-400%', transition: _vm.slideTransformDuration, transform: _vm.rightSlide5Translate}),attrs:{"screenWidthSmall":_vm.screenWidthSmall}})],1)]),_vm._v(" "),(_vm.showModalLandingPopup)?_c('modal-landing-popup'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v3lv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navSlideComponent',

  props: ['setClassContainer', 'setClassImage', 'setIdImage', 'setSourceImage', 'setStyleContainer', 'setStyleImage'],

  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var imageDocument = document.getElementById(this.setIdImage);
    imageDocument.onload = function () {
      this.$emit('imageMounted', true);
    }.bind(this);
  }
});

/***/ }),

/***/ "w1Cw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aboutComponent',

  props: ['screenWidthSmall'],

  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_body_container_component_vue__ = __webpack_require__("O17j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_lollicup_css__ = __webpack_require__("iuAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_lollicup_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_lollicup_css__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BodyContainerComponent: __WEBPACK_IMPORTED_MODULE_0__components_body_container_component_vue__["a" /* default */]
  },

  name: 'app'
});

/***/ }),

/***/ "y4XA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.setClassContainer,style:(_vm.setStyleContainer)},[_c('img',{class:_vm.setClassImage,style:(_vm.setStyleImage),attrs:{"id":_vm.setIdImage,"src":_vm.setSourceImage}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yrLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: [{
    dairy: false,
    favorite: false,
    flavor: 'Almond',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Avocado',
    premium: true
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Banana',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Blueberry',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Cantaloupe',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Cappuccino',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Caramel',
    premium: true
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Cherry',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Chocolate',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Chocolate Mint',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Chocolate Peanut',
    premium: true
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Coconut',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Coffee',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Coffee Toffee',
    premium: true
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Cookies \'n Cream',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Cranberry',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Ginger',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Grape',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Grapefruit',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Green Apple',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Green Bean',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Guava',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Honey Dew',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Kiwi',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Kumquat',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Lavender',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Lemon',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Lychee',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Matcha Green Tea',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Mango',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Papaya',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Passion',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Peach',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Pear',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Peppermint',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Pina Colada',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Pineapple',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Pistachio',
    premium: true
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Pomegranate',
    premium: true
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Pumpkin',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Raspberry',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Red Bean',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Red Velvet',
    premium: true
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Rose',
    premium: true
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Royal',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Sesame',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Sour Plum',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Strawberry',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Strawberry Yogurt',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Tangerine',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Taro',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Thai',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'Vanilla',
    premium: false
  }, {
    dairy: true,
    favorite: false,
    flavor: 'White Chocolate',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Wintermelon',
    premium: false
  }, {
    dairy: false,
    favorite: false,
    flavor: 'Yogurt',
    premium: false
  }]
});

/***/ }),

/***/ "zANs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_landing_popup_vue__ = __webpack_require__("OCDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd5e036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_landing_popup_vue__ = __webpack_require__("38EM");
function injectStyle (ssrContext) {
  __webpack_require__("oxG6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_landing_popup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd5e036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_landing_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c0be1bff4e368fdeb9d2.js